export const OPTIONAL_CLASS_FEATURE_CREATE = 'character.OPTIONAL_CLASS_FEATURE_CREATE';
export const OPTIONAL_CLASS_FEATURE_ADD = 'character.OPTIONAL_CLASS_FEATURE_ADD';
export const OPTIONAL_CLASS_FEATURE_ADD_COMMIT = 'character.OPTIONAL_CLASS_FEATURE_ADD_COMMIT';
export const OPTIONAL_CLASS_FEATURE_SET_REQUEST = 'character.OPTIONAL_CLASS_FEATURE_SET_REQUEST';
export const OPTIONAL_CLASS_FEATURE_SET = 'character.OPTIONAL_CLASS_FEATURE_SET';
export const OPTIONAL_CLASS_FEATURE_SET_COMMIT = 'character.OPTIONAL_CLASS_FEATURE_SET_COMMIT';
export const OPTIONAL_CLASS_FEATURE_DESTROY = 'character.OPTIONAL_CLASS_FEATURE_DESTROY';
export const OPTIONAL_CLASS_FEATURE_REMOVE = 'character.OPTIONAL_CLASS_FEATURE_REMOVE';
export const OPTIONAL_CLASS_FEATURE_REMOVE_COMMIT = 'character.OPTIONAL_CLASS_FEATURE_REMOVE_COMMIT';
